module.exports = __webpack_public_path__ + "img/iPhone10_sml-978b3318883e13c030323a044011ff5d.png";